<template>
  <div class="panel result">
    <div class="panel-block p-5">
      <b-icon
        :icon="policyIcon"
        size="is-large"
        custom-size="fa-4x"
        :type="policyType" />
      <span class="has-text-centered pt-5">{{ policyResultText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Policy',
  props: {
    eligibility: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      type: {
        Approved: 'is-success',
        Reviewable: 'is-warning',
        Refused: 'is-danger'
      },
      policyResult: {
        Approved: 'Cumple',
        Reviewable: 'En revisión',
        Refused: 'No cumple'
      },
      icon: {
        Approved: 'check-circle',
        Reviewable: 'exclamation-circle',
        Refused: 'times-circle'
      }
    };
  },
  computed: {
    policyIcon() {
      return this.icon[this.eligibility];
    },
    policyType() {
      return this.type[this.eligibility];
    },
    policyResultText() {
      return this.policyResult[this.eligibility];
    }
  }
};
</script>

<style scoped>
.panel{
  box-shadow: none;
}
.panel .panel-block{
  border: 1px solid #E9E9E9;
  border-radius: 10px;
}
.panel.result {
  height: 100%;
}
#resume .panel.result .panel-block{
  height: 100%;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
